// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import { ExtraErrorData as ExtraErrorDataIntegration } from '@sentry/integrations';
import { init } from '@sentry/nextjs';
import { AxiosError } from 'axios';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

if (SENTRY_DSN) {
  init({
    dsn:
      SENTRY_DSN ||
      'https://88e04cea4cd6452baad07092a51a6305@o1075109.ingest.sentry.io/4504137763389440',
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 0.0,
    // ...
    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps
    integrations: [
      new ExtraErrorDataIntegration({
        // Limit of how deep the object serializer should go. Anything deeper than limit will
        // be replaced with standard Node.js REPL notation of [Object], [Array], [Function] or
        // a primitive value. Defaults to 3.
        depth: 10,
      }),
    ],
    beforeSend(event, hint) {
      const originalException = hint?.originalException;

      // Only send AxiosError as client errors can be tracked from hotjar
      if (originalException instanceof AxiosError) {
        return event;
      }

      // Ignore all other errors
      return null;
    },
  });
}
